import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { EnzymesModel } from '../../../../shared/entities/enzimes.model';
import { EnzymesService } from '../../../../shared/services/app/enzymes.service';

@Component({
  selector: 'app-enzymes-add-edit',
  templateUrl: './enzymes-add-edit.component.html',
  styleUrls: ['./enzymes-add-edit.component.scss']
})
export class EnzymesAddEditComponent implements OnInit {

    public uid: string = null;
    public enzymeModel: EnzymesModel = new EnzymesModel();
    public loading = false;
    public form: UntypedFormGroup;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private enzymeService: EnzymesService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }

    }

    onCloseDialog(enzyme: EnzymesModel) {
        this.ref.close(enzyme);
    }

    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.enzymeModel.uid],
            name: [this.enzymeModel.name, [Validators.required, Validators.maxLength(200)]],
        });
    }

    getItem(): void {
        this.loading = true;
        this.enzymeService.get(this.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.enzymeModel.map(response.payload);
                this.form.patchValue(this.enzymeModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        this.enzymeService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.enzymeModel.map(response.payload);
                this.form.patchValue(this.enzymeModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Enzima a fost salvat cu success!'
                });
                this.ref.close(this.enzymeModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }
}
